<div class="container-fluid box d-flex flex-column pb-3 pt-2 full-size">
  <app-explorer-main-menu [explorerManager]="explorerManager"></app-explorer-main-menu>

  <div class="flex-grow-1 d-flex">
    <div>
      <app-explorer-side-bar [explorerManager]="explorerManager"></app-explorer-side-bar>
    </div>
    <div class="flex-grow-1 pl-2">
      <app-explorer-view [windowId]="windowId" [explorerManager]="explorerManager"></app-explorer-view>
    </div>
  </div>

  <app-explorer-footer></app-explorer-footer>
</div>